import axios from "axios";
import moment from "moment";
import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../utils/queryParams";
import { API_DATE_FORMAT } from "../../../../app_constants";

export const SET_LOADING = "saga/retention/introBreakdown/SET_LOADING";
export const SET_UPDATES_LOADING = "saga/retention/introBreakdown/SET_UPDATES_LOADING";

export const SET_DATES = "saga/SET_DATES";

export const UPDATE_DATES = "saga/retention/introBreakdown/UPDATE_DATES";
export const UPDATE_PRICING_OPTIONS = "saga/retention/introBreakdown/UPDATE_PRICING_OPTIONS";

export const FETCH_CURRENT_USER = "sagas/retention/introBreakdown/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS =
  "sagas/retention/introBreakdown/FETCH_CURRENT_USER_SUCCESS";

export const FETCH_FILTERS_SUCCESS = "sagas/retention/introBreakdown/FETCH_FILTERS_SUCCESS";
export const FETCH_VALUES = "sagas/retention/introBreakdown/FETCH_VALUES";

export const UPDATE_CUSTOM_RANGE = "sagas/retention/introBreakdown/UPDATE_CUSTOM_RANGE";
export const UPDATE_DATA = "sagas/retention/introBreakdown/UPDATE_DATA";

export const RESET_DATA = "sagas/retention/introBreakdown/RESET_DATA";
export const RESET_FILTERS = "sagas/retention/introBreakdown/RESET_FILTERS";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updatePricingOptions: createAction(UPDATE_PRICING_OPTIONS),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  updateData: createAction(UPDATE_DATA),
  updateDates: createAction(UPDATE_DATES),
  resetData: createAction(RESET_DATA)
};

export default function* watchIntroBreakdown() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(UPDATE_DATA, updateData);
  yield takeLatest(RESET_DATA, resetData);
}

function* setDates(startDate, endDate) {
  yield put({
    type: SET_DATES,
    payload: {
      startDate,
      endDate
    }
  });
}

function* getDatesHelper() {
  const endDate = yield select((state) => state.introBreakdown.currentUser.calendarEndDate);
  const startDate = moment(endDate).startOf("month").format(API_DATE_FORMAT);

  return [startDate, endDate];
}

function* getCommonApiParams() {
  const { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);
  return yield select((state) => {
    const {
      selectedRequestDates: { startDate, endDate },
      selectedPricingOptions
    } = state.introBreakdown;
    const pricingOptions = selectedPricingOptions.map((option) => option.id).join(",");

    return [organization_id.toString(), short_url, startDate, endDate, pricingOptions];
  });
}

function* fetchCurrentUserData(data) {
  yield put({ type: SET_LOADING, payload: true });

  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: data.payload
  });

  let dates = yield getDatesHelper();
  yield setDates(...dates);

  try {
    yield fetchFilters();
    yield fetchValues();

    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* fetchFilters(usePrev = false) {
  const [organization_id, short_url, start_date, end_date] = yield getCommonApiParams();

  let params = { organization_id, short_url, start_date, end_date };
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion + `pages/retention/intro_breakdown/get_intro_breakdown_filters`,
      { params }
    );
    yield put({ type: FETCH_FILTERS_SUCCESS, payload: { data: response.data, usePrev } });
  } catch (err) {
    console.error(err);
  }
}

function* fetchValues() {
  const [organization_id, short_url, start_date, end_date, pricing_option_ids] =
    yield getCommonApiParams();

  const params = {
    organization_id,
    short_url,
    start_date,
    end_date,
    pricing_option_ids
  };
  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + `pages/retention/intro_breakdown/get_intro_breakdown_values`,
      params
    );
    yield put({ type: FETCH_VALUES, payload: response.data });
  } catch (err) {
    console.error(err);
  }
}

function* updateData() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  let { datesDirty } = yield select((state) => state.introBreakdown);

  try {
    if (datesDirty) yield fetchFilters(true);
    yield fetchValues();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (err) {
    console.error(err);
  }
}

function* resetData() {
  yield put({ type: SET_LOADING, payload: true });
  try {
    yield put({ type: RESET_FILTERS });

    let dates = yield getDatesHelper();
    yield setDates(...dates);
    yield fetchFilters();
    yield fetchValues();
    yield put({ type: SET_LOADING, payload: false });
  } catch (err) {
    console.error(err);
  }
}
